import styled from 'styled-components';

import theme from '@/styles/theme';

interface MaterialIconProps {
  name: string;
  size?: number;
  color?: string;
  filled?: boolean;
}

/**
 *
 * @param name string
 * @param size number (optional)
 * @param color number (optional)
 * @param filled number (optional)
 * @default
 * size 24px
 * color theme.color.GRAY900
 * filled false
 *
 * @example
 * <MaterialIcon name={'thumb_down'} size={32} filled />
 *
 */

const MaterialIcon = ({
  name,
  size = 24,
  color = theme.DF_COLOR.GRAY900,
  filled = false
}: MaterialIconProps) => {
  return (
    <Wrapper width={size} className={'material_icon'}>
      <Icon
        className={`material-symbols-rounded`}
        size={size}
        color={color}
        filled={filled}>
        {name}
      </Icon>
    </Wrapper>
  );
};

export default MaterialIcon;

const Wrapper = styled.div<{ width: number }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ width }) => width}px;
`;
const Icon = styled.span<{
  size: number;
  color: string;
  filled: boolean;
}>`
  ${({ size, color, filled }) => `
    font-size: ${size}px;
    color: ${color};
    font-variation-settings: 
      'GRAD' 0, 
      'opsz' 24, 
      'wght' 400,
      'FILL' ${filled ? 1 : 0};   
      
  `};
  overflow: hidden;
`;
